AuthRoute = require 'mixins/authenticated-route'

App.AdvertsRoute = Em.Route.extend AuthRoute,
  queryParams:
    actuality:
      refreshModel: true

  model: ->
    # Хак чтобы список обновлялся если добавится или удалится модель
    organization_id = @get('session').get('currentOrganization.id')
    Em.RSVP.hash {
      restaurants: @store.find('restaurant', { organization_id }),
      promos: @store.find('promo', { organization_id }),
      adverts: @store.find('advert', { organization_id })
    }


  actions:
    goBackToAdvertList: ->
      @transitionTo 'adverts'
      false
